module.exports = __webpack_public_path__ + "static/media/empty.6e08ebc7.svg";